import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import packageJson from '../../../../../package.json';
import { LanguageSelector } from '../language-selector.component';
import { ThemeSelector } from '../theme-selector.component';

const appVersion = `v${packageJson.version}-${process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV || 'dev'}`;

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-[24px] mt-[40px] border-t border-border-dark/[0.07]">
      <div className="flex flex-col sm:flex-row justify-between gap-[12px]">
        <div className="flex flex-col gap-[4px]">
          <p className="font-body text-[13px] text-content-muted">
            {t('footer.company')}
          </p>
          <p className="font-body text-[12px] text-gray-700">
            {t('footer.copyright')}
          </p>
        </div>
        <div className="flex gap-[16px] items-start flex-wrap">
          <ThemeSelector />
          <LanguageSelector direction="up" />
          <Link
            to="/terms"
            className="font-body text-[13px] text-content-muted hover:text-base-black transition-colors"
          >
            {t('footer.terms')}
          </Link>
          <Link
            to="/privacy"
            className="font-body text-[13px] text-content-muted hover:text-base-black transition-colors"
          >
            {t('footer.privacy')}
          </Link>
          <button
            type="button"
            onClick={() => {
              localStorage.removeItem('squarebit_store_cookie_consent');
              window.location.reload();
            }}
            className="font-body text-[13px] text-content-muted hover:text-base-black transition-colors"
          >
            {t('footer.cookies')}
          </button>
        </div>
      </div>
      <p className="font-body text-[12px] text-gray-500 text-center mt-[16px]">
        {appVersion}
      </p>
    </footer>
  );
};

export default Footer;
